import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { products } from '../../data/products';
import { useCart } from '../../context/CartContext';
import ProductImageGallery from '../../components/ProductImageGallery';
import RelatedProducts from '../../components/RelatedProducts';

const WirelessKeyboard = () => {
  const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [currentImage, setCurrentImage] = useState('');
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [quantity, setQuantity] = useState(1);
  
  // 获取键盘产品数据
  const keyboard = products.find(p => p.category === 'keyboards');
  
  // 版本图片映射
  const versionImages = {
    'Rose Gold + Keyboard only': '/images/shop-products/wireless-keyboard/pink.png',
    'Silver + Keyboard only': '/images/shop-products/wireless-keyboard/sliver.png',
    'Black + Keyboard only': '/images/shop-products/wireless-keyboard/space gray.png'
  };

  // 版本选项
  const versionOptions = [
    {
      name: 'Rose Gold + Keyboard only',
      description: 'Pink Edition',
      image: versionImages['Rose Gold + Keyboard only'],
      price: 20.90,
      inStock: false
    },
    {
      name: 'Silver + Keyboard only',
      description: 'Silver Edition',
      image: versionImages['Silver + Keyboard only'],
      price: 20.90,
      inStock: false
    },
    {
      name: 'Black + Keyboard only',
      description: 'Black Edition',
      image: versionImages['Black + Keyboard only'],
      price: 20.90,
      inStock: true
    }
  ];

  // 更多图片
  const additionalImages = [
    '/images/shop-products/wireless-keyboard/KEYBOARD ONLY.jpg', // 主图
    versionImages[selectedVersion], // 当前选择的版本
    versionImages['Rose Gold + Keyboard only'],
    versionImages['Silver + Keyboard only'],
    versionImages['Black + Keyboard only'],
    '/images/shop-products/wireless-keyboard/s-l400.jpeg', // 额外图片
    '/images/shop-products/wireless-keyboard/f3df05d2610aa072fac69544bcc6cb31.jpeg', // 额外图片2
    '/images/shop-products/wireless-keyboard/167bc6940e0babb2b8a24dccd1588290.jpeg' // 额外图片3
  ];

  // 初始化当前图片
  useEffect(() => {
    setCurrentImage('/images/shop-products/wireless-keyboard/KEYBOARD ONLY.jpg');
  }, []);

  // 当版本改变时更新图片
  useEffect(() => {
    if (selectedVersion && versionImages[selectedVersion]) {
      setCurrentImage(versionImages[selectedVersion]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVersion]);


  // 格式化价格
  const formatPrice = (price) => {
    // 如果价格已经是格式化的字符串（如 "S$22.90"），直接返回
    if (typeof price === 'string') {
      return price;
    }
    // 如果价格是数字，格式化为 "S$" 格式
    return `S$${price.toFixed(2)}`;
  };

  // 获取当前价格
  const getCurrentPrice = () => {
    const selectedVersionData = versionOptions.find(v => v.name === selectedVersion);
    return selectedVersionData ? selectedVersionData.price : 20.90;
  };

  // 获取当前价格字符串
  const getCurrentPriceString = () => {
    const price = getCurrentPrice();
    return formatPrice(price);
  };

  // 添加到购物车
  const handleAddToCart = () => {
    const cartItem = {
      id: `${keyboard.id}-${selectedVersion}`,
      name: `${keyboard.name} - ${selectedVersion}`,
      price: getCurrentPrice(),
      quantity: quantity,
      image: versionImages[selectedVersion],
      version: selectedVersion
    };
    addToCart(cartItem);
  };

  // 立即购买
  const handleBuyNow = () => {
    handleAddToCart();
    // 这里可以添加跳转到购物车页面的逻辑
  };

  return (
    <div className="container mx-auto px-4 py-12 text-white">
      {/* 面包屑导航 */}
      <div className="text-sm text-gray-400 mb-6">
        <Link to="/" className="hover:text-white">Home</Link> / 
        <Link to="/shop" className="hover:text-white mx-2">Shop</Link> / 
        <Link to="/shop/keyboards" className="hover:text-white mr-2">Keyboards</Link> / 
        <span className="text-white">3-Mode Wireless Bluetooth Keyboard and Mouse Set</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* 左侧产品图片 */}
        <div>
          <ProductImageGallery
            images={additionalImages}
            currentImage={currentImage}
            onImageChange={setCurrentImage}
          />
        </div>
        
        {/* 右侧产品信息 */}
        <div>
          <h1 className="text-3xl font-bold mb-2">3-Mode Wireless Bluetooth Keyboard and Mouse Set</h1>
          
          {/* 评分 */}
          <div className="flex items-center mb-4">
            <div className="flex text-yellow-400">
              {[...Array(5)].map((_, i) => (
                <span key={i} className={i < 4 ? "text-yellow-400" : "text-gray-600"}>★</span>
              ))}
            </div>
            <span className="ml-2 text-gray-400">(128 reviews)</span>
          </div>
          
                     {/* 价格 */}
           <div className="mb-6">
             <span className="text-3xl font-bold">{getCurrentPriceString()}</span>
             <div className="text-sm text-gray-400 mt-2">
               Current Selection: {selectedVersion || 'No version selected'}
             </div>
           </div>
          
          {/* 库存状态 */}
          <div className="mb-6">
            {versionOptions.find(v => v.name === selectedVersion)?.inStock ? (
              <span className="text-green-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                In Stock
              </span>
            ) : (
              <span className="text-red-500 flex items-center">
                <svg className="w-5 h-5 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                Sold Out
              </span>
            )}
          </div>
          
          {/* 简短描述 */}
          <p className="text-gray-300 mb-6">3-Mode Wireless Bluetooth Keyboard and Mouse Set – Rechargeable, Compatible with 2.4G/BT 3.0/BT 5.0</p>
          
          {/* 选择版本 */}
          <div className="mb-6">
            <h3 className="text-lg font-medium mb-3">Choose Version</h3>
            <div className="space-y-3">
              {versionOptions.map((version) => (
                <button 
                  key={version.name}
                  className={`w-full border rounded-lg p-4 transition-all duration-200 ${
                    selectedVersion === version.name
                      ? 'border-green-500 bg-green-500/10'
                      : 'border-gray-700 hover:border-green-400'
                  } ${!version.inStock ? 'opacity-50 cursor-not-allowed' : ''}`}
                  onClick={() => version.inStock && setSelectedVersion(version.name)}
                  disabled={!version.inStock}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <img
                        src={version.image}
                        alt={version.name}
                        className="w-16 h-16 rounded-md object-cover aspect-square"
                        onError={(e) => { e.target.src = '/images/products/placeholder.jpg'; }}
                      />
                      <div className="text-left">
                        <div className="text-white font-medium">{version.name}</div>
                        <div className="text-gray-400 text-sm">{version.description}</div>
                        <div className="text-xs text-green-500 font-medium mt-1">{formatPrice(version.price)}</div>
                      </div>
                    </div>
                    <div className="text-right">
                      {!version.inStock && (
                        <div className="text-red-500 text-sm font-medium">SOLD OUT</div>
                      )}
                      {selectedVersion === version.name && version.inStock && (
                        <div className="text-green-500 text-sm">✓ Selected</div>
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
          
          {/* Quantity */}
          <div className="mb-8">
            <h3 className="text-lg font-medium mb-3">Quantity</h3>
            <div className="flex items-center">
              <button 
                className="bg-gray-800 px-4 py-2 rounded-l-md"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <input 
                type="text" 
                value={quantity} 
                readOnly
                className="bg-gray-800 text-center w-16 py-2 border-x border-gray-700"
              />
              <button 
                className="bg-gray-800 px-4 py-2 rounded-r-md"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </button>
            </div>
          </div>
          
                     {/* Purchase Buttons */}
           <div className="grid grid-cols-2 gap-4 mb-6">
             <button 
               className={`py-3 px-6 rounded-md font-medium ${
                 selectedVersion && versionOptions.find(v => v.name === selectedVersion)?.inStock
                   ? 'bg-green-600 hover:bg-green-700 text-white'
                   : 'bg-gray-600 text-gray-400 cursor-not-allowed'
               }`}
               onClick={handleAddToCart}
               disabled={!selectedVersion || !versionOptions.find(v => v.name === selectedVersion)?.inStock}
             >
               {selectedVersion ? 'Add to Cart' : 'Please Select Colour'}
             </button>
             <button 
               className={`py-3 px-6 rounded-md font-medium ${
                 selectedVersion && versionOptions.find(v => v.name === selectedVersion)?.inStock
                   ? 'bg-gray-800 hover:bg-gray-700 text-white border border-gray-600'
                   : 'bg-gray-600 text-gray-400 cursor-not-allowed border border-gray-600'
               }`}
               onClick={handleBuyNow}
               disabled={!selectedVersion || !versionOptions.find(v => v.name === selectedVersion)?.inStock}
             >
               {selectedVersion ? 'Buy Now' : 'Please Select Colour'}
             </button>
           </div>
          
          {/* Shipping Info */}
          <div className="border-t border-gray-700 pt-6">
            <div className="flex items-center mb-3">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2a1 1 0 00.9-.5l1.5-2A1 1 0 0015 7h-3V4a1 1 0 00-1-1H3zM14 7l-1.5 2H10V5h4v2z" />
              </svg>
              <span className="text-gray-300">Free Meet Up (Available at Sengkang & Orchard locations)</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              <span className="text-gray-300">Available Shipping</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* 产品详情标签页 */}
      <div className="mt-16">
        <div className="border-b border-gray-700 mb-8">
          <nav className="flex space-x-8">
            {['overview', 'specifications', 'reviews'].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                  activeTab === tab
                    ? 'border-green-500 text-green-500'
                    : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'
                }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </nav>
        </div>
        
        <div className="text-gray-300">
          {activeTab === 'overview' && (
            <div>
              <h3 className="text-xl font-semibold text-white mb-4">Product Overview</h3>
              <p className="mb-4">
                Experience the future of wireless connectivity with our 3-Mode Wireless Bluetooth Keyboard and Mouse Set. 
                This rechargeable set offers compatibility with 2.4G, Bluetooth 3.0, and Bluetooth 5.0, 
                ensuring seamless connection across all your devices.
              </p>
              <p className="mb-4">
                Choose from our exclusive color editions - Pink, Space Gray, and Silver. Each edition features 
                premium materials and precision engineering, delivering exceptional performance for both gaming and productivity.
              </p>
            </div>
          )}
          
          {activeTab === 'specifications' && (
            <div>
              <h3 className="text-xl font-semibold text-white mb-4">Technical Specifications</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-medium text-white mb-2">Connectivity</h4>
                  <ul className="space-y-1 text-sm">
                    <li>• 2.4G Wireless</li>
                    <li>• Bluetooth 3.0</li>
                    <li>• Bluetooth 5.0</li>
                    <li>• USB-C Rechargeable</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-medium text-white mb-2">Features</h4>
                  <ul className="space-y-1 text-sm">
                    <li>• 3-Mode Connectivity</li>
                    <li>• Rechargeable Battery</li>
                    <li>• Multi-Device Support</li>
                    <li>• Ergonomic Design</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'reviews' && (
            <div>
              <h3 className="text-xl font-semibold text-white mb-4">Customer Reviews</h3>
              <p className="text-gray-400">Customer reviews will be displayed here.</p>
            </div>
          )}
        </div>
      </div>
      
      {/* 相关产品 */}
      <RelatedProducts 
        currentProductId={keyboard.id} 
        currentCategory={keyboard.category} 
        limit={4} 
      />
    </div>
  );
};

export default WirelessKeyboard;
